import utils from 'live/lib/utils'

const URL = '/services/plugin-purge/purge'

const api = {
    getSources: (): Promise<Response> => {
        const urlSources = '/rest/widget-sources'

        return fetch(urlSources, {
            method: 'GET',
            credentials: utils.fetchDefaults.credentials,
            headers: utils.fetchDefaults.headers
        })
    },
    getPurgeDef: (): Promise<Response> => {
        const url = `${URL}/purgeDef`

        return fetch(url, {
            method: 'GET',
            credentials: utils.fetchDefaults.credentials,
            headers: utils.fetchDefaults.headers
        })
    },
    simulateTask: (): Promise<Response> => {
        const url = `${URL}/task/simulate`

        return fetch(url, {
            method: 'POST',
            credentials: utils.fetchDefaults.credentials,
            headers: utils.fetchDefaults.headers
        })
    },
    runTask: (): Promise<Response> => {
        const url = `${URL}/task/run`

        return fetch(url, {
            method: 'POST',
            credentials: utils.fetchDefaults.credentials,
            headers: utils.fetchDefaults.headers
        })
    },
    cancelTask: (purgeId: string): Promise<Response> => {
        const url = `${URL}/task/${purgeId}/cancel`

        return fetch(url, {
            method: 'POST',
            credentials: utils.fetchDefaults.credentials,
            headers: utils.fetchDefaults.headers
        })
    },
    savePurgeRule: (purgeRule: PurgeRule): Promise<Response> => {
        const url = `${URL}/rule`

        return fetch(url, {
            method: 'POST',
            credentials: utils.fetchDefaults.credentials,
            headers: utils.fetchDefaults.headers,
            body: JSON.stringify(purgeRule)
        })
    },
    editPurgeRule: (oldPurgeRule: PurgeRule, newPurgeRule: PurgeRule): Promise<Response> => {
        const url = `${URL}/rule`

        return fetch(url, {
            method: 'PUT',
            credentials: utils.fetchDefaults.credentials,
            headers: utils.fetchDefaults.headers,
            body: JSON.stringify({ oldPurgeRule, newPurgeRule })
        })
    },
    removePurgeRule: (purgeRule: PurgeRule): Promise<Response> => {
        const url = `${URL}/rule`

        return fetch(url, {
            method: 'DELETE',
            credentials: utils.fetchDefaults.credentials,
            headers: utils.fetchDefaults.headers,
            body: JSON.stringify(purgeRule)
        })
    },
    savePurgeExceptionRule: (purgeExceptionRule: PurgeExceptionRule): Promise<Response> => {
        const url = `${URL}/exception`

        return fetch(url, {
            method: 'POST',
            credentials: utils.fetchDefaults.credentials,
            headers: utils.fetchDefaults.headers,
            body: JSON.stringify(purgeExceptionRule)
        })
    },
    editPurgeExceptionRule: (
        oldPurgeExceptionRule: PurgeExceptionRule,
        newPurgeExceptionRule: PurgeExceptionRule
    ): Promise<Response> => {
        const url = `${URL}/exception`

        return fetch(url, {
            method: 'PUT',
            credentials: utils.fetchDefaults.credentials,
            headers: utils.fetchDefaults.headers,
            body: JSON.stringify({ oldPurgeExceptionRule, newPurgeExceptionRule })
        })
    },
    removePurgeExceptionRule: (purgeExceptionRule: PurgeExceptionRule): Promise<Response> => {
        const url = `${URL}/exception`

        return fetch(url, {
            method: 'DELETE',
            credentials: utils.fetchDefaults.credentials,
            headers: utils.fetchDefaults.headers,
            body: JSON.stringify(purgeExceptionRule)
        })
    },
    getPurgeSettings: (): Promise<Response> => {
        const url = `${URL}/config`

        return fetch(url)
    },
    savePurgeSettings: (purgeConfig: PurgeConfig): Promise<Response> => {
        const url = `${URL}/config`

        return fetch(url, {
            method: 'POST',
            credentials: utils.fetchDefaults.credentials,
            body: JSON.stringify(purgeConfig),
            headers: utils.fetchDefaults.headers
        })
    }
}

export default api
